module.exports = __webpack_public_path__ + "omniv2/img/security-confirm-shield.b2db1da4.svg";